export const VALIDATION_MESSAGES = {
  oneLowercaseChar: 'One lowercase character',
  oneUppercaseChar: 'One uppercase character',
  oneNumber: 'One number',
  oneSpecialChar: 'One special character',
  minLength: '8 characters minimum',
  signatorName: 'First and Last Name required',
  notEmpty: 'Field is required.',
};

export const oneLowercaseChar = (value: string) => (!/[a-z]/.test(value) ? VALIDATION_MESSAGES.oneLowercaseChar : undefined);

export const oneUppercaseChar = (value: string) => (!/[A-Z]/.test(value) ? VALIDATION_MESSAGES.oneUppercaseChar : undefined);

export const oneNumber = (value: string) => (!/[0-9]/.test(value) ? VALIDATION_MESSAGES.oneNumber : undefined);

export const oneSpecialChar = (value: string) => (!/[^A-Za-z 0-9]/g.test(value) ? VALIDATION_MESSAGES.oneSpecialChar : undefined);

export const minLength = (value: string) => (value.length < 8 ? VALIDATION_MESSAGES.minLength : undefined);

export const notEmpty = (value: string) => (value && value.trim().length === 0 ? VALIDATION_MESSAGES.notEmpty : undefined);

export const signatorEmptyOrValid = (value: string) => (value && value.trim().length <= 2 ? VALIDATION_MESSAGES.signatorName : undefined);
